import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, RequestMethod, URLSearchParams } from "@angular/http";
import { Observable } from "rxjs";
import { Subject } from 'rxjs/Subject';
import { Router } from "@angular/router";

@Injectable()
export class ApiAnnuaireService {
  protected _apiUrlBase = environment.base_api;
  
  public annuaireFormDatasSubject = new Subject<Object>();
  public annuaireFormDatas;

  public annuaireResults;

  constructor(private _http : Http, private router : Router) { 
    this.annuaireFormDatasSubject.asObservable().subscribe( data => {
      this.annuaireFormDatas = data;
      localStorage.setItem('vvad-form', JSON.stringify(data));
    });
  }

  setAnnuaireFormDatas(
    rubrique : String,
    sousRubrique : String,
    categorie : String,
    entreprise : String,
    ville : String
  ) 
  {
    this.annuaireFormDatasSubject.next(
      {
        'rubrique' : rubrique,
        'sousRubrique' : sousRubrique,
        'categorie' : categorie,
        'entreprise' : entreprise,
        'ville' : ville,
      }
    );
  }

  getAnnuaireFormDatas() {
    if(this.annuaireFormDatas === undefined) {
      var jsonLocalStorage = JSON.parse(localStorage.getItem('vvad-form'));

      if (jsonLocalStorage == null) {
        this.setAnnuaireFormDatas('','','', '', '');
        return this.annuaireFormDatas;
      } else {
        return JSON.parse(localStorage.getItem('vvad-form'));
      }
      
    } else {
      return this.annuaireFormDatas;
    }
  }

  getEntreprisesByFilter(offset) : Promise<any> {
    let body = new URLSearchParams();
    let result;

    body.set('filters', JSON.stringify(this.getAnnuaireFormDatas()));
    body.set('offset', offset);

    return new Promise((resolve, reject) => {
      this._http
        .post(this._apiUrlBase+'/annuaire/entreprises/filter', body)
        .subscribe(response => {
          console.log('- GET ENTREPRISES - ', response);
          let entreprises = response.json();
          let data = [];

          entreprises.payload.results.forEach(element => {
            data = [
              ...data, 
              { 
                ...element, 
                titleFormatted: (element.sigle != '') ? element.raison_sociale + ' <span>(' + element.sigle + ')</span>' : element.raison_sociale
              }
            ];
          });

          entreprises.payload.results = data;

          resolve(entreprises.payload);
        })
      })
  }

  initializeFormAnnuaire() : Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
          .get(this._apiUrlBase+'/annuaire/initialize')
          .subscribe(response => {
            let results = response.json();

              resolve(results.payload);
          })
    })
  }

  getSubRubrique(idRubrique) : Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
          .get(this._apiUrlBase+'/annuaire/entreprises/sous-rubriques/'+idRubrique)
          .subscribe(response => {
            let results = response.json();

              resolve(results.payload);
          })
    })
  }
  
  getCategories(idSousRubrique) : Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
          .get(this._apiUrlBase+'/annuaire/entreprises/categories/'+idSousRubrique)
          .subscribe(response => {
            let results = response.json();

              resolve(results.payload);
          })
    })
  }

  getEntreprise(id) : Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
          .get(this._apiUrlBase+'/annuaire/entreprise/'+id)
          .subscribe(response => {
            let results = response.json();

              resolve(results.payload);
          })
    })
  }



  getTotalEntreprises() : Observable<any> {
    return this._http.get(this._apiUrlBase+'/allo_diagnostic/')
      .map((res) => {
        if(res.status === 200){
          let resJSON = res.json();

          return res.json();
        }else {
          return Observable.of({});
        }
      }).catch((error) => {
        return Observable.of({});
      });
  }

  getEntreprisesByZone(id, offset) : Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
        .get(this._apiUrlBase + '/annuaire/entreprisebyza/'+id+'/'+offset)
        .subscribe(response => {
          let results = response.json();
          let data = [];

          results.payload.forEach(element => {
            data = [
              ...data, 
              { 
                ...element, 
                titleFormatted: (element.sigle != '') ? element.raison_sociale + ' <span>(' + element.sigle + ')</span>' : element.raison_sociale
              }
            ];
          });

          results.payload = data;

          resolve(results.payload);
        })
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/annuaire/services/api-annuaire.service.ts